@for (avatar of avatars; track avatar.title) {
    <companyid-avatar-with-message
        [avatarImg]="avatar.avatarImg"
        [classNames]="avatar.classNames"
        [position]="avatar.position"
        [title]="avatar.title"
        [smile]="avatar.smile"
        [subtitle]="avatar.subtitle" />
}
